import { render, staticRenderFns } from "./QuickLinkView.vue?vue&type=template&id=a0ce8d98&scoped=true&"
import script from "./QuickLinkView.vue?vue&type=script&lang=ts&"
export * from "./QuickLinkView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ce8d98",
  null
  
)

export default component.exports